import type { JSX } from "react";

import { Button } from "@frontend/components/atoms/Button";
import { Icon } from "@frontend/components/atoms/Icon";
import type { IconName } from "@frontend/components/atoms/Icon";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@frontend/components/atoms/Tooltip";

export type FieldActionButtonProps = {
  icon: IconName;
  label: string;
  disabled?: boolean;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
};

export function FieldActionButton({
  icon,
  label,
  disabled,
  onClick,
}: FieldActionButtonProps): JSX.Element {
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            variant="ghost"
            size="sm"
            disabled={disabled}
            aria-label={label}
            onClick={onClick}
          >
            <Icon name={icon} size="sm" />
          </Button>
        }
      />

      <TooltipContent side="top">{label}</TooltipContent>
    </Tooltip>
  );
}
